import { render, staticRenderFns } from "./AlertLogFile.vue?vue&type=template&id=2bfdf16e&scoped=true&"
import script from "./AlertLogFile.vue?vue&type=script&lang=js&"
export * from "./AlertLogFile.vue?vue&type=script&lang=js&"
import style0 from "./AlertLogFile.vue?vue&type=style&index=0&id=2bfdf16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdf16e",
  null
  
)

export default component.exports